import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=eaea2310&"
import script from "./PlaceOrder.vue?vue&type=script&lang=ts&"
export * from "./PlaceOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports